import Service from './service'
export var ApiScriptMessageType;
(function (ApiScriptMessageType) {
  ApiScriptMessageType["SCRIPTS_START_RESULT"] = "system.scripts.start.result"
  ApiScriptMessageType["SCRIPTS_END"] = "system.scripts.end"
  ApiScriptMessageType["SCRIPTS_CONTROL"] = "system.scripts.control"
})(ApiScriptMessageType || (ApiScriptMessageType = {}))
export var ScriptMessageType;
(function (ScriptMessageType) {
  ScriptMessageType["SCRIPT_END"] = "SCRIPT_END"
})(ScriptMessageType || (ScriptMessageType = {}))
/**
 * Сервис для работы со скриптами
 * @version 0.0.1
 * @since 1.9.0
 */
export default class ScriptsService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiScriptMessageType.SCRIPTS_START_RESULT:
          this.resolve(this.waiters.scripts, message.result)
          break
        case ApiScriptMessageType.SCRIPTS_END:
          this.broadcast(ScriptMessageType.SCRIPT_END)
          break
      }
    }
    this.waiters = {
      scripts: [],
    }
    this.messageChannel.subscribe(ApiScriptMessageType.SCRIPTS_START_RESULT, messageHandler)
    this.messageChannel.subscribe(ApiScriptMessageType.SCRIPTS_END, messageHandler)
  }
  /**
     * Скрипт закончен
     * @since 1.9.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof ScriptsService
     *
     * @example <caption>Скрипт закончен</caption>
     * robot.scriptsService.onScriptEnd(() => {
     *   ...
     * })
     */
  onScriptEnd(callback) {
    return this.subscribe(ScriptMessageType.SCRIPT_END, callback)
  }
  /**
     * Запустить скрипт
     * @since 1.9.0
     * @param {string} name - имя скрипта
     * @return {*}  {Promise<string>}
     * @memberof ScriptsService
     *
     * @example <caption>Запустить скрипт</caption>
     * robot.scriptsService.startScript(name).then((result) => {
     *   console.log('using system', result)
     * })
     */
  startScript(name) {
    return this.execute({
      type: ApiScriptMessageType.SCRIPTS_CONTROL,
      start: name,
    }, this.waiters.scripts)
  }
  /**
     * Остановить скрипт
     * @since 1.9.0
     * @memberof ScriptsService
     *
     * @example <caption>Остановить скрипт</caption>
     * robot.scriptsService.stopScript()
     */
  stopScript() {
    this.messageChannel.send({
      type: ApiScriptMessageType.SCRIPTS_CONTROL,
      stop: '',
    })
  }
}
